import { FC } from 'react';
import { connect } from 'react-redux';

import './DesktopGetTheAppPopup/desktopGetTheAppPopup.scss';
import { PopupSlicer } from 'store/popup/PopupActions';
import { GetTheAppSlicer, onSendAppLink as sendLink } from 'store/getTheApp/GetTheAppActions';
import { IStore2, ServerStatus } from 'store/types';
import { checkSmallScreen } from 'utils';
import MobileGetTheAppPopup from './MobileGetTheAppPopup/MobileGetTheAppPopup';
import DesktopGetTheAppPopup from './DesktopGetTheAppPopup/DesktopGetTheAppPopup';

export interface IGetTheApp {
  hide(): void;
  onPhoneSubmit(input: { phone: string }): void;
  serverErrorMessage?: string;
  serverStatus: ServerStatus | null;
  resetServerStatus(): void;
}

export const GetTheAppPopup: FC<IGetTheApp> = ({
  hide,
  onPhoneSubmit,
  serverStatus,
  serverErrorMessage,
  resetServerStatus,
}) => {
  const onHide = () => {
    resetServerStatus();
    hide();
  };

  const isMobile = checkSmallScreen();

  const popupToRender = () => {
    if (isMobile) {
      return <MobileGetTheAppPopup onHide={onHide} />;
    }

    return (
      <DesktopGetTheAppPopup
        isSuccess={isSuccess}
        onHide={onHide}
        onPhoneSubmit={onPhoneSubmit}
        serverErrorMessage={serverErrorMessage}
      />
    );
  };

  const isSuccess = serverStatus === ServerStatus.SUCCESS;

  return popupToRender();
};

const mapStateToProps = (state: IStore2) => {
  const { serverErrorMessage, serverStatus } = state.getTheApp;

  return { serverErrorMessage, serverStatus };
};

const mapDispatchToProps = {
  hide: PopupSlicer.actions.hide,
  onPhoneSubmit: sendLink,
  resetServerStatus: GetTheAppSlicer.actions.resetStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(GetTheAppPopup);
